var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLoginSocialApple = function SvgIconLoginSocialApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.186 10.522c-.009-1.503.672-2.635 2.047-3.47-.769-1.102-1.933-1.708-3.466-1.825-1.452-.114-3.041.846-3.623.846-.614 0-2.02-.806-3.126-.806-2.283.035-4.71 1.82-4.71 5.451 0 1.073.197 2.182.589 3.323.524 1.503 2.415 5.185 4.387 5.126 1.031-.025 1.76-.732 3.103-.732 1.302 0 1.976.732 3.127.732 1.99-.029 3.7-3.376 4.197-4.883-2.668-1.259-2.525-3.685-2.525-3.762Zm-2.316-6.72c1.117-1.327 1.016-2.535.983-2.969-.987.058-2.129.672-2.779 1.428-.716.811-1.137 1.814-1.046 2.944 1.066.082 2.04-.467 2.842-1.403Z",
    fill: "currentColor"
  })));
};
export default SvgIconLoginSocialApple;